import Styled from 'styled-components/macro';

const Content = Styled.div`
  width: ${(props) => (props.narrow ? props.theme.global.narrowWidth : props.theme.global.width)};
  max-width: calc(100% - 4rem);
  margin: 0 auto;
`;

export default Content;
